import type { LinkUrl, LinksButtonComponent } from '@twisto/api-cms'
import { TextButton } from '@twisto/components/atoms/button'

import { getLinkUrl } from 'homepage/utils'

type Props = {
  link: LinksButtonComponent
  increaseFontSize?: boolean
}
export const Button = ({ link, increaseFontSize = false }: Props) => (
  <li>
    <TextButton
      fullWidth
      href={link.url}
      size={increaseFontSize ? 'medium' : 'small'}
      target={link.newTab === true ? '_blank' : undefined}
      to={getLinkUrl(link as LinkUrl)}
    >
      {link.text}
    </TextButton>
  </li>
)
